import React, { Component } from 'react'

/**
 * This basic component is a dead simple wrapper to provide "paragraph" styling.
 * Using the html <p> method was constraining due to the fact that <div> can't
 * be a child of <p>
 */
export default class CalcParagraph extends Component {
  /**
   * Render the component
   * @returns
   */
  render () {
    return <div className='calcPara'>{this.props.children}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/CalcParagraph.js